// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PagesRouteImport } from './routes/_pages'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as McpRouteImport } from './routes/mcp'
import { Route as PreviewRouteImport } from './routes/preview'
import { Route as RegionenRouteImport } from './routes/regionen'
import { Route as PagesAccessDeniedRouteImport } from './routes/_pages/access-denied'
import { Route as PagesDatenschutzRouteImport } from './routes/_pages/datenschutz'
import { Route as PagesKontaktRouteImport } from './routes/_pages/kontakt'
import { Route as PagesOAuthErrorRouteImport } from './routes/_pages/oAuthError'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminApiTokensRouteImport } from './routes/admin/api-tokens'
import { Route as AdminAuditLogRouteImport } from './routes/admin/audit-log'
import { Route as AdminDataSchemaRouteImport } from './routes/admin/data-schema'
import { Route as AdminLayerOrderRouteImport } from './routes/admin/layer-order'
import { Route as AdminMapDatasetCategoriesRouteImport } from './routes/admin/map-dataset-categories'
import { Route as AdminMapDatasetUploadsRouteImport } from './routes/admin/map-dataset-uploads'
import { Route as AdminNoteFoldersRouteImport } from './routes/admin/note-folders'
import { Route as AdminPrivateBackgroundsRouteImport } from './routes/admin/private-backgrounds'
import { Route as AdminProcessingRouteImport } from './routes/admin/processing'
import { Route as AdminQaConfigsRouteImport } from './routes/admin/qa-configs'
import { Route as AdminRegionContractsRouteImport } from './routes/admin/region-contracts'
import { Route as AdminRegionsRouteImport } from './routes/admin/regions'
import { Route as AdminReviewListsRouteImport } from './routes/admin/review-lists'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as ApiBoundaryRouteImport } from './routes/api/boundary'
import { Route as ApiCampaignsRouteImport } from './routes/api/campaigns'
import { Route as ApiMapStyleRouteImport } from './routes/api/map-style'
import { Route as ApiOsmcha2RssRewriteRouteImport } from './routes/api/osmcha2-rss-rewrite'
import { Route as ApiProcessingDatesRouteImport } from './routes/api/processing-dates'
import { Route as ApiProcessingDatesMapillaryRouteImport } from './routes/api/processing-dates-mapillary'
import { Route as ApiRegionsRouteImport } from './routes/api/regions'
import { Route as ApiStatsRouteImport } from './routes/api/stats'
import { Route as ApiUploadsRouteImport } from './routes/api/uploads'
import { Route as PreviewDefaultErrorRouteImport } from './routes/preview/default-error'
import { Route as PreviewDefaultPendingRouteImport } from './routes/preview/default-pending'
import { Route as PreviewNotFoundRouteImport } from './routes/preview/not-found'
import { Route as PreviewRegionErrorRouteImport } from './routes/preview/region-error'
import { Route as PreviewRegionPendingRouteImport } from './routes/preview/region-pending'
import { Route as PreviewRootFallbackRouteImport } from './routes/preview/root-fallback'
import { Route as RegionenIndexRouteImport } from './routes/regionen/index'
import { Route as RegionenRegionSlugRouteRouteImport } from './routes/regionen/$regionSlug/route'
import { Route as RegionenStatsRouteImport } from './routes/regionen/stats'
import { Route as PagesDocsTableNameRouteImport } from './routes/_pages/docs.$tableName'
import { Route as PagesDocsMapillaryCoverageRouteImport } from './routes/_pages/docs.mapillary-coverage'
import { Route as PagesSettingsUserRouteImport } from './routes/_pages/settings.user'
import { Route as AdminMapDatasetCategoriesIndexRouteImport } from './routes/admin/map-dataset-categories/index'
import { Route as AdminMapDatasetCategoriesCategoryKeyRouteImport } from './routes/admin/map-dataset-categories/$categoryKey'
import { Route as AdminMapDatasetCategoriesNewRouteImport } from './routes/admin/map-dataset-categories/new'
import { Route as AdminMapDatasetUploadsIndexRouteImport } from './routes/admin/map-dataset-uploads/index'
import { Route as AdminMapDatasetUploadsSlugRouteImport } from './routes/admin/map-dataset-uploads/$slug'
import { Route as AdminMembershipsNewRouteImport } from './routes/admin/memberships/new'
import { Route as AdminNoteFoldersIndexRouteImport } from './routes/admin/note-folders/index'
import { Route as AdminPrivateBackgroundsIndexRouteImport } from './routes/admin/private-backgrounds/index'
import { Route as AdminProcessingIndexRouteImport } from './routes/admin/processing/index'
import { Route as AdminProcessingMetaIdRouteImport } from './routes/admin/processing/$metaId'
import { Route as AdminProcessingHooksRouteImport } from './routes/admin/processing/hooks'
import { Route as AdminQaConfigsIndexRouteImport } from './routes/admin/qa-configs/index'
import { Route as AdminQaConfigsNewRouteImport } from './routes/admin/qa-configs/new'
import { Route as AdminRegionContractsIndexRouteImport } from './routes/admin/region-contracts/index'
import { Route as AdminRegionContractsNewRouteImport } from './routes/admin/region-contracts/new'
import { Route as AdminRegionsIndexRouteImport } from './routes/admin/regions/index'
import { Route as AdminRegionsNewRouteImport } from './routes/admin/regions/new'
import { Route as AdminReviewListsIndexRouteImport } from './routes/admin/review-lists/index'
import { Route as AdminUsersIndexRouteImport } from './routes/admin/users/index'
import { Route as ApiAdminAuditLogRouteImport } from './routes/api/admin/audit-log'
import { Route as ApiAdminProcessingRouteImport } from './routes/api/admin/processing'
import { Route as ApiAdminRegionUploadsRouteImport } from './routes/api/admin/region-uploads'
import { Route as ApiAdminRegionsRouteImport } from './routes/api/admin/regions'
import { Route as ApiAuthSplatRouteImport } from './routes/api/auth.$'
import { Route as ApiAuthOsmTokenRouteImport } from './routes/api/auth.osm-token'
import { Route as ApiNotesRegionSlugRouteImport } from './routes/api/notes.$regionSlug'
import { Route as ApiOsmNotesRssRouteImport } from './routes/api/osm-notes.rss'
import { Route as ApiPrivateGenerateMaprouletteTasksRouteImport } from './routes/api/private/generate-maproulette-tasks'
import { Route as ApiPrivatePostProcessingHookRouteImport } from './routes/api/private/post-processing-hook'
import { Route as ApiPrivatePostProcessingQaUpdateRouteImport } from './routes/api/private/post-processing-qa-update'
import { Route as ApiPrivateRegionsRouteImport } from './routes/api/private/regions'
import { Route as ApiPrivateRegisterSqlFunctionsRouteImport } from './routes/api/private/register-sql-functions'
import { Route as ApiPrivateWarmCacheRouteImport } from './routes/api/private/warm-cache'
import { Route as ApiReviewListsUploadRouteImport } from './routes/api/review-lists.upload'
import { Route as ApiSignInOsmRouteImport } from './routes/api/sign-in.osm'
import { Route as ApiUploadsSlugRouteImport } from './routes/api/uploads.$slug'
import { Route as ApiUploadsCreateRouteImport } from './routes/api/uploads.create'
import { Route as RegionenRegionSlugIndexRouteImport } from './routes/regionen/$regionSlug/index'
import { Route as RegionenRegionSlugHinweiseRouteImport } from './routes/regionen/$regionSlug/hinweise'
import { Route as RegionenRegionSlugMessenRouteImport } from './routes/regionen/$regionSlug/messen'
import { Route as RegionenRegionSlugPrueflistenRouteImport } from './routes/regionen/$regionSlug/prueflisten'
import { Route as RegionenRegionSlugQaRouteImport } from './routes/regionen/$regionSlug/qa'
import { Route as RegionenRegionSlugSummierenRouteImport } from './routes/regionen/$regionSlug/summieren'
import { Route as AdminNoteFoldersIdEditRouteImport } from './routes/admin/note-folders/$id.edit'
import { Route as AdminQaConfigsIdEditRouteImport } from './routes/admin/qa-configs/$id.edit'
import { Route as AdminRegionContractsSlugEditRouteImport } from './routes/admin/region-contracts/$slug.edit'
import { Route as AdminRegionsRegionSlugEditRouteImport } from './routes/admin/regions/$regionSlug.edit'
import { Route as AdminReviewListsIdEditRouteImport } from './routes/admin/review-lists/$id.edit'
import { Route as AdminUsersUserIdEditRouteImport } from './routes/admin/users/$userId.edit'
import { Route as ApiAdminDataSchemaImportRouteImport } from './routes/api/admin/data-schema.import'
import { Route as ApiAdminProcessingMetaIdRouteImport } from './routes/api/admin/processing.$metaId'
import { Route as ApiAdminRegionUploadsUploadRouteImport } from './routes/api/admin/region-uploads.upload'
import { Route as ApiAdminRegionsSlugRouteImport } from './routes/api/admin/regions.$slug'
import { Route as ApiExportOgrRegionSlugTableNameRouteImport } from './routes/api/export-ogr.$regionSlug.$tableName'
import { Route as ApiExportRegionSlugTableNameRouteImport } from './routes/api/export.$regionSlug.$tableName'
import { Route as ApiMaprouletteDataProjectKeyRouteImport } from './routes/api/maproulette.data.$projectKey'
import { Route as ApiMaprouletteDataTest_tag_fixRouteImport } from './routes/api/maproulette.data.test_tag_fix'
import { Route as ApiMaprouletteDataTest_tag_fix_cyclewaySharedRouteImport } from './routes/api/maproulette.data.test_tag_fix_cycleway-shared'
import { Route as ApiMaprouletteDataTest_tag_fix_twoRouteImport } from './routes/api/maproulette.data.test_tag_fix_two'
import { Route as ApiMaprouletteStatisticProxyChallengeIdRouteImport } from './routes/api/maproulette.statistic-proxy.$challengeId'
import { Route as ApiNotesRegionSlugFolderIdRouteImport } from './routes/api/notes.$regionSlug.$folderId'
import { Route as ApiNotesRegionSlugDownloadRouteImport } from './routes/api/notes.$regionSlug.download'
import { Route as ApiRegionUploadsIdFilenameRouteImport } from './routes/api/region-uploads.$id.$filename'
import { Route as ApiRegionsRegionSlugUploadsCsvRouteImport } from './routes/api/regions.$regionSlug.uploads-csv'
import { Route as ApiAdminQaConfigsIdExportCsvRouteImport } from './routes/api/admin.qa-configs.$id.export-csv'
import { Route as ApiNotesRegionSlugFolderIdNoteIdRouteImport } from './routes/api/notes.$regionSlug.$folderId.$noteId'
import { Route as ApiNotesRegionSlugFolderIdNoteIdCommentsRouteImport } from './routes/api/notes.$regionSlug.$folderId.$noteId.comments'
import { Route as ApiPrivateBackgroundsSlugZXYRouteImport } from './routes/api/private-backgrounds.$slug.$z.$x.$y'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const PagesRoute = PagesRouteImport.update({
            id: '/_pages',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const McpRoute = McpRouteImport.update({
            id: '/mcp',path: '/mcp',getParentRoute: () => rootRouteImport
          })
const PreviewRoute = PreviewRouteImport.update({
            id: '/preview',path: '/preview',getParentRoute: () => rootRouteImport
          })
const RegionenRoute = RegionenRouteImport.update({
            id: '/regionen',path: '/regionen',getParentRoute: () => rootRouteImport
          })
const PagesAccessDeniedRoute = PagesAccessDeniedRouteImport.update({
            id: '/access-denied',path: '/access-denied',getParentRoute: () => PagesRoute
          })
const PagesDatenschutzRoute = PagesDatenschutzRouteImport.update({
            id: '/datenschutz',path: '/datenschutz',getParentRoute: () => PagesRoute
          })
const PagesKontaktRoute = PagesKontaktRouteImport.update({
            id: '/kontakt',path: '/kontakt',getParentRoute: () => PagesRoute
          })
const PagesOAuthErrorRoute = PagesOAuthErrorRouteImport.update({
            id: '/oAuthError',path: '/oAuthError',getParentRoute: () => PagesRoute
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          })
const AdminApiTokensRoute = AdminApiTokensRouteImport.update({
            id: '/api-tokens',path: '/api-tokens',getParentRoute: () => AdminRoute
          })
const AdminAuditLogRoute = AdminAuditLogRouteImport.update({
            id: '/audit-log',path: '/audit-log',getParentRoute: () => AdminRoute
          })
const AdminDataSchemaRoute = AdminDataSchemaRouteImport.update({
            id: '/data-schema',path: '/data-schema',getParentRoute: () => AdminRoute
          })
const AdminLayerOrderRoute = AdminLayerOrderRouteImport.update({
            id: '/layer-order',path: '/layer-order',getParentRoute: () => AdminRoute
          })
const AdminMapDatasetCategoriesRoute = AdminMapDatasetCategoriesRouteImport.update({
            id: '/map-dataset-categories',path: '/map-dataset-categories',getParentRoute: () => AdminRoute
          })
const AdminMapDatasetUploadsRoute = AdminMapDatasetUploadsRouteImport.update({
            id: '/map-dataset-uploads',path: '/map-dataset-uploads',getParentRoute: () => AdminRoute
          })
const AdminNoteFoldersRoute = AdminNoteFoldersRouteImport.update({
            id: '/note-folders',path: '/note-folders',getParentRoute: () => AdminRoute
          })
const AdminPrivateBackgroundsRoute = AdminPrivateBackgroundsRouteImport.update({
            id: '/private-backgrounds',path: '/private-backgrounds',getParentRoute: () => AdminRoute
          })
const AdminProcessingRoute = AdminProcessingRouteImport.update({
            id: '/processing',path: '/processing',getParentRoute: () => AdminRoute
          })
const AdminQaConfigsRoute = AdminQaConfigsRouteImport.update({
            id: '/qa-configs',path: '/qa-configs',getParentRoute: () => AdminRoute
          })
const AdminRegionContractsRoute = AdminRegionContractsRouteImport.update({
            id: '/region-contracts',path: '/region-contracts',getParentRoute: () => AdminRoute
          })
const AdminRegionsRoute = AdminRegionsRouteImport.update({
            id: '/regions',path: '/regions',getParentRoute: () => AdminRoute
          })
const AdminReviewListsRoute = AdminReviewListsRouteImport.update({
            id: '/review-lists',path: '/review-lists',getParentRoute: () => AdminRoute
          })
const AdminUsersRoute = AdminUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AdminRoute
          })
const ApiBoundaryRoute = ApiBoundaryRouteImport.update({
            id: '/api/boundary',path: '/api/boundary',getParentRoute: () => rootRouteImport
          })
const ApiCampaignsRoute = ApiCampaignsRouteImport.update({
            id: '/api/campaigns',path: '/api/campaigns',getParentRoute: () => rootRouteImport
          })
const ApiMapStyleRoute = ApiMapStyleRouteImport.update({
            id: '/api/map-style',path: '/api/map-style',getParentRoute: () => rootRouteImport
          })
const ApiOsmcha2RssRewriteRoute = ApiOsmcha2RssRewriteRouteImport.update({
            id: '/api/osmcha2-rss-rewrite',path: '/api/osmcha2-rss-rewrite',getParentRoute: () => rootRouteImport
          })
const ApiProcessingDatesRoute = ApiProcessingDatesRouteImport.update({
            id: '/api/processing-dates',path: '/api/processing-dates',getParentRoute: () => rootRouteImport
          })
const ApiProcessingDatesMapillaryRoute = ApiProcessingDatesMapillaryRouteImport.update({
            id: '/api/processing-dates-mapillary',path: '/api/processing-dates-mapillary',getParentRoute: () => rootRouteImport
          })
const ApiRegionsRoute = ApiRegionsRouteImport.update({
            id: '/api/regions',path: '/api/regions',getParentRoute: () => rootRouteImport
          })
const ApiStatsRoute = ApiStatsRouteImport.update({
            id: '/api/stats',path: '/api/stats',getParentRoute: () => rootRouteImport
          })
const ApiUploadsRoute = ApiUploadsRouteImport.update({
            id: '/api/uploads',path: '/api/uploads',getParentRoute: () => rootRouteImport
          })
const PreviewDefaultErrorRoute = PreviewDefaultErrorRouteImport.update({
            id: '/default-error',path: '/default-error',getParentRoute: () => PreviewRoute
          })
const PreviewDefaultPendingRoute = PreviewDefaultPendingRouteImport.update({
            id: '/default-pending',path: '/default-pending',getParentRoute: () => PreviewRoute
          })
const PreviewNotFoundRoute = PreviewNotFoundRouteImport.update({
            id: '/not-found',path: '/not-found',getParentRoute: () => PreviewRoute
          })
const PreviewRegionErrorRoute = PreviewRegionErrorRouteImport.update({
            id: '/region-error',path: '/region-error',getParentRoute: () => PreviewRoute
          })
const PreviewRegionPendingRoute = PreviewRegionPendingRouteImport.update({
            id: '/region-pending',path: '/region-pending',getParentRoute: () => PreviewRoute
          })
const PreviewRootFallbackRoute = PreviewRootFallbackRouteImport.update({
            id: '/root-fallback',path: '/root-fallback',getParentRoute: () => PreviewRoute
          })
const RegionenIndexRoute = RegionenIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => RegionenRoute
          })
const RegionenRegionSlugRouteRoute = RegionenRegionSlugRouteRouteImport.update({
            id: '/$regionSlug',path: '/$regionSlug',getParentRoute: () => RegionenRoute
          })
const RegionenStatsRoute = RegionenStatsRouteImport.update({
            id: '/stats',path: '/stats',getParentRoute: () => RegionenRoute
          })
const PagesDocsTableNameRoute = PagesDocsTableNameRouteImport.update({
            id: '/docs/$tableName',path: '/docs/$tableName',getParentRoute: () => PagesRoute
          })
const PagesDocsMapillaryCoverageRoute = PagesDocsMapillaryCoverageRouteImport.update({
            id: '/docs/mapillary-coverage',path: '/docs/mapillary-coverage',getParentRoute: () => PagesRoute
          })
const PagesSettingsUserRoute = PagesSettingsUserRouteImport.update({
            id: '/settings/user',path: '/settings/user',getParentRoute: () => PagesRoute
          })
const AdminMapDatasetCategoriesIndexRoute = AdminMapDatasetCategoriesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminMapDatasetCategoriesRoute
          })
const AdminMapDatasetCategoriesCategoryKeyRoute = AdminMapDatasetCategoriesCategoryKeyRouteImport.update({
            id: '/$categoryKey',path: '/$categoryKey',getParentRoute: () => AdminMapDatasetCategoriesRoute
          })
const AdminMapDatasetCategoriesNewRoute = AdminMapDatasetCategoriesNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => AdminMapDatasetCategoriesRoute
          })
const AdminMapDatasetUploadsIndexRoute = AdminMapDatasetUploadsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminMapDatasetUploadsRoute
          })
const AdminMapDatasetUploadsSlugRoute = AdminMapDatasetUploadsSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => AdminMapDatasetUploadsRoute
          })
const AdminMembershipsNewRoute = AdminMembershipsNewRouteImport.update({
            id: '/memberships/new',path: '/memberships/new',getParentRoute: () => AdminRoute
          })
const AdminNoteFoldersIndexRoute = AdminNoteFoldersIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminNoteFoldersRoute
          })
const AdminPrivateBackgroundsIndexRoute = AdminPrivateBackgroundsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminPrivateBackgroundsRoute
          })
const AdminProcessingIndexRoute = AdminProcessingIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminProcessingRoute
          })
const AdminProcessingMetaIdRoute = AdminProcessingMetaIdRouteImport.update({
            id: '/$metaId',path: '/$metaId',getParentRoute: () => AdminProcessingRoute
          })
const AdminProcessingHooksRoute = AdminProcessingHooksRouteImport.update({
            id: '/hooks',path: '/hooks',getParentRoute: () => AdminProcessingRoute
          })
const AdminQaConfigsIndexRoute = AdminQaConfigsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminQaConfigsRoute
          })
const AdminQaConfigsNewRoute = AdminQaConfigsNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => AdminQaConfigsRoute
          })
const AdminRegionContractsIndexRoute = AdminRegionContractsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRegionContractsRoute
          })
const AdminRegionContractsNewRoute = AdminRegionContractsNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => AdminRegionContractsRoute
          })
const AdminRegionsIndexRoute = AdminRegionsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRegionsRoute
          })
const AdminRegionsNewRoute = AdminRegionsNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => AdminRegionsRoute
          })
const AdminReviewListsIndexRoute = AdminReviewListsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminReviewListsRoute
          })
const AdminUsersIndexRoute = AdminUsersIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminUsersRoute
          })
const ApiAdminAuditLogRoute = ApiAdminAuditLogRouteImport.update({
            id: '/api/admin/audit-log',path: '/api/admin/audit-log',getParentRoute: () => rootRouteImport
          })
const ApiAdminProcessingRoute = ApiAdminProcessingRouteImport.update({
            id: '/api/admin/processing',path: '/api/admin/processing',getParentRoute: () => rootRouteImport
          })
const ApiAdminRegionUploadsRoute = ApiAdminRegionUploadsRouteImport.update({
            id: '/api/admin/region-uploads',path: '/api/admin/region-uploads',getParentRoute: () => rootRouteImport
          })
const ApiAdminRegionsRoute = ApiAdminRegionsRouteImport.update({
            id: '/api/admin/regions',path: '/api/admin/regions',getParentRoute: () => rootRouteImport
          })
const ApiAuthSplatRoute = ApiAuthSplatRouteImport.update({
            id: '/api/auth/$',path: '/api/auth/$',getParentRoute: () => rootRouteImport
          })
const ApiAuthOsmTokenRoute = ApiAuthOsmTokenRouteImport.update({
            id: '/api/auth/osm-token',path: '/api/auth/osm-token',getParentRoute: () => rootRouteImport
          })
const ApiNotesRegionSlugRoute = ApiNotesRegionSlugRouteImport.update({
            id: '/api/notes/$regionSlug',path: '/api/notes/$regionSlug',getParentRoute: () => rootRouteImport
          })
const ApiOsmNotesRssRoute = ApiOsmNotesRssRouteImport.update({
            id: '/api/osm-notes/rss',path: '/api/osm-notes/rss',getParentRoute: () => rootRouteImport
          })
const ApiPrivateGenerateMaprouletteTasksRoute = ApiPrivateGenerateMaprouletteTasksRouteImport.update({
            id: '/api/private/generate-maproulette-tasks',path: '/api/private/generate-maproulette-tasks',getParentRoute: () => rootRouteImport
          })
const ApiPrivatePostProcessingHookRoute = ApiPrivatePostProcessingHookRouteImport.update({
            id: '/api/private/post-processing-hook',path: '/api/private/post-processing-hook',getParentRoute: () => rootRouteImport
          })
const ApiPrivatePostProcessingQaUpdateRoute = ApiPrivatePostProcessingQaUpdateRouteImport.update({
            id: '/api/private/post-processing-qa-update',path: '/api/private/post-processing-qa-update',getParentRoute: () => rootRouteImport
          })
const ApiPrivateRegionsRoute = ApiPrivateRegionsRouteImport.update({
            id: '/api/private/regions',path: '/api/private/regions',getParentRoute: () => rootRouteImport
          })
const ApiPrivateRegisterSqlFunctionsRoute = ApiPrivateRegisterSqlFunctionsRouteImport.update({
            id: '/api/private/register-sql-functions',path: '/api/private/register-sql-functions',getParentRoute: () => rootRouteImport
          })
const ApiPrivateWarmCacheRoute = ApiPrivateWarmCacheRouteImport.update({
            id: '/api/private/warm-cache',path: '/api/private/warm-cache',getParentRoute: () => rootRouteImport
          })
const ApiReviewListsUploadRoute = ApiReviewListsUploadRouteImport.update({
            id: '/api/review-lists/upload',path: '/api/review-lists/upload',getParentRoute: () => rootRouteImport
          })
const ApiSignInOsmRoute = ApiSignInOsmRouteImport.update({
            id: '/api/sign-in/osm',path: '/api/sign-in/osm',getParentRoute: () => rootRouteImport
          })
const ApiUploadsSlugRoute = ApiUploadsSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => ApiUploadsRoute
          })
const ApiUploadsCreateRoute = ApiUploadsCreateRouteImport.update({
            id: '/create',path: '/create',getParentRoute: () => ApiUploadsRoute
          })
const RegionenRegionSlugIndexRoute = RegionenRegionSlugIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => RegionenRegionSlugRouteRoute
          })
const RegionenRegionSlugHinweiseRoute = RegionenRegionSlugHinweiseRouteImport.update({
            id: '/hinweise',path: '/hinweise',getParentRoute: () => RegionenRegionSlugRouteRoute
          })
const RegionenRegionSlugMessenRoute = RegionenRegionSlugMessenRouteImport.update({
            id: '/messen',path: '/messen',getParentRoute: () => RegionenRegionSlugRouteRoute
          })
const RegionenRegionSlugPrueflistenRoute = RegionenRegionSlugPrueflistenRouteImport.update({
            id: '/prueflisten',path: '/prueflisten',getParentRoute: () => RegionenRegionSlugRouteRoute
          })
const RegionenRegionSlugQaRoute = RegionenRegionSlugQaRouteImport.update({
            id: '/qa',path: '/qa',getParentRoute: () => RegionenRegionSlugRouteRoute
          })
const RegionenRegionSlugSummierenRoute = RegionenRegionSlugSummierenRouteImport.update({
            id: '/summieren',path: '/summieren',getParentRoute: () => RegionenRegionSlugRouteRoute
          })
const AdminNoteFoldersIdEditRoute = AdminNoteFoldersIdEditRouteImport.update({
            id: '/$id/edit',path: '/$id/edit',getParentRoute: () => AdminNoteFoldersRoute
          })
const AdminQaConfigsIdEditRoute = AdminQaConfigsIdEditRouteImport.update({
            id: '/$id/edit',path: '/$id/edit',getParentRoute: () => AdminQaConfigsRoute
          })
const AdminRegionContractsSlugEditRoute = AdminRegionContractsSlugEditRouteImport.update({
            id: '/$slug/edit',path: '/$slug/edit',getParentRoute: () => AdminRegionContractsRoute
          })
const AdminRegionsRegionSlugEditRoute = AdminRegionsRegionSlugEditRouteImport.update({
            id: '/$regionSlug/edit',path: '/$regionSlug/edit',getParentRoute: () => AdminRegionsRoute
          })
const AdminReviewListsIdEditRoute = AdminReviewListsIdEditRouteImport.update({
            id: '/$id/edit',path: '/$id/edit',getParentRoute: () => AdminReviewListsRoute
          })
const AdminUsersUserIdEditRoute = AdminUsersUserIdEditRouteImport.update({
            id: '/$userId/edit',path: '/$userId/edit',getParentRoute: () => AdminUsersRoute
          })
const ApiAdminDataSchemaImportRoute = ApiAdminDataSchemaImportRouteImport.update({
            id: '/api/admin/data-schema/import',path: '/api/admin/data-schema/import',getParentRoute: () => rootRouteImport
          })
const ApiAdminProcessingMetaIdRoute = ApiAdminProcessingMetaIdRouteImport.update({
            id: '/$metaId',path: '/$metaId',getParentRoute: () => ApiAdminProcessingRoute
          })
const ApiAdminRegionUploadsUploadRoute = ApiAdminRegionUploadsUploadRouteImport.update({
            id: '/upload',path: '/upload',getParentRoute: () => ApiAdminRegionUploadsRoute
          })
const ApiAdminRegionsSlugRoute = ApiAdminRegionsSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => ApiAdminRegionsRoute
          })
const ApiExportOgrRegionSlugTableNameRoute = ApiExportOgrRegionSlugTableNameRouteImport.update({
            id: '/api/export-ogr/$regionSlug/$tableName',path: '/api/export-ogr/$regionSlug/$tableName',getParentRoute: () => rootRouteImport
          })
const ApiExportRegionSlugTableNameRoute = ApiExportRegionSlugTableNameRouteImport.update({
            id: '/api/export/$regionSlug/$tableName',path: '/api/export/$regionSlug/$tableName',getParentRoute: () => rootRouteImport
          })
const ApiMaprouletteDataProjectKeyRoute = ApiMaprouletteDataProjectKeyRouteImport.update({
            id: '/api/maproulette/data/$projectKey',path: '/api/maproulette/data/$projectKey',getParentRoute: () => rootRouteImport
          })
const ApiMaprouletteDataTest_tag_fixRoute = ApiMaprouletteDataTest_tag_fixRouteImport.update({
            id: '/api/maproulette/data/test_tag_fix',path: '/api/maproulette/data/test_tag_fix',getParentRoute: () => rootRouteImport
          })
const ApiMaprouletteDataTest_tag_fix_cyclewaySharedRoute = ApiMaprouletteDataTest_tag_fix_cyclewaySharedRouteImport.update({
            id: '/api/maproulette/data/test_tag_fix_cycleway-shared',path: '/api/maproulette/data/test_tag_fix_cycleway-shared',getParentRoute: () => rootRouteImport
          })
const ApiMaprouletteDataTest_tag_fix_twoRoute = ApiMaprouletteDataTest_tag_fix_twoRouteImport.update({
            id: '/api/maproulette/data/test_tag_fix_two',path: '/api/maproulette/data/test_tag_fix_two',getParentRoute: () => rootRouteImport
          })
const ApiMaprouletteStatisticProxyChallengeIdRoute = ApiMaprouletteStatisticProxyChallengeIdRouteImport.update({
            id: '/api/maproulette/statistic-proxy/$challengeId',path: '/api/maproulette/statistic-proxy/$challengeId',getParentRoute: () => rootRouteImport
          })
const ApiNotesRegionSlugFolderIdRoute = ApiNotesRegionSlugFolderIdRouteImport.update({
            id: '/$folderId',path: '/$folderId',getParentRoute: () => ApiNotesRegionSlugRoute
          })
const ApiNotesRegionSlugDownloadRoute = ApiNotesRegionSlugDownloadRouteImport.update({
            id: '/download',path: '/download',getParentRoute: () => ApiNotesRegionSlugRoute
          })
const ApiRegionUploadsIdFilenameRoute = ApiRegionUploadsIdFilenameRouteImport.update({
            id: '/api/region-uploads/$id/$filename',path: '/api/region-uploads/$id/$filename',getParentRoute: () => rootRouteImport
          })
const ApiRegionsRegionSlugUploadsCsvRoute = ApiRegionsRegionSlugUploadsCsvRouteImport.update({
            id: '/$regionSlug/uploads-csv',path: '/$regionSlug/uploads-csv',getParentRoute: () => ApiRegionsRoute
          })
const ApiAdminQaConfigsIdExportCsvRoute = ApiAdminQaConfigsIdExportCsvRouteImport.update({
            id: '/api/admin/qa-configs/$id/export-csv',path: '/api/admin/qa-configs/$id/export-csv',getParentRoute: () => rootRouteImport
          })
const ApiNotesRegionSlugFolderIdNoteIdRoute = ApiNotesRegionSlugFolderIdNoteIdRouteImport.update({
            id: '/$noteId',path: '/$noteId',getParentRoute: () => ApiNotesRegionSlugFolderIdRoute
          })
const ApiNotesRegionSlugFolderIdNoteIdCommentsRoute = ApiNotesRegionSlugFolderIdNoteIdCommentsRouteImport.update({
            id: '/comments',path: '/comments',getParentRoute: () => ApiNotesRegionSlugFolderIdNoteIdRoute
          })
const ApiPrivateBackgroundsSlugZXYRoute = ApiPrivateBackgroundsSlugZXYRouteImport.update({
            id: '/api/private-backgrounds/$slug/$z/$x/$y',path: '/api/private-backgrounds/$slug/$z/$x/$y',getParentRoute: () => rootRouteImport
          })





const PagesRouteChildren = {
  PagesAccessDeniedRoute: PagesAccessDeniedRoute,PagesDatenschutzRoute: PagesDatenschutzRoute,PagesKontaktRoute: PagesKontaktRoute,PagesOAuthErrorRoute: PagesOAuthErrorRoute,PagesDocsTableNameRoute: PagesDocsTableNameRoute,PagesDocsMapillaryCoverageRoute: PagesDocsMapillaryCoverageRoute,PagesSettingsUserRoute: PagesSettingsUserRoute
}

const PagesRouteWithChildren = PagesRoute._addFileChildren(PagesRouteChildren)




const AdminMapDatasetCategoriesRouteChildren = {
  AdminMapDatasetCategoriesCategoryKeyRoute: AdminMapDatasetCategoriesCategoryKeyRoute,AdminMapDatasetCategoriesNewRoute: AdminMapDatasetCategoriesNewRoute,AdminMapDatasetCategoriesIndexRoute: AdminMapDatasetCategoriesIndexRoute
}

const AdminMapDatasetCategoriesRouteWithChildren = AdminMapDatasetCategoriesRoute._addFileChildren(AdminMapDatasetCategoriesRouteChildren)




const AdminMapDatasetUploadsRouteChildren = {
  AdminMapDatasetUploadsSlugRoute: AdminMapDatasetUploadsSlugRoute,AdminMapDatasetUploadsIndexRoute: AdminMapDatasetUploadsIndexRoute
}

const AdminMapDatasetUploadsRouteWithChildren = AdminMapDatasetUploadsRoute._addFileChildren(AdminMapDatasetUploadsRouteChildren)




const AdminNoteFoldersRouteChildren = {
  AdminNoteFoldersIndexRoute: AdminNoteFoldersIndexRoute,AdminNoteFoldersIdEditRoute: AdminNoteFoldersIdEditRoute
}

const AdminNoteFoldersRouteWithChildren = AdminNoteFoldersRoute._addFileChildren(AdminNoteFoldersRouteChildren)




const AdminPrivateBackgroundsRouteChildren = {
  AdminPrivateBackgroundsIndexRoute: AdminPrivateBackgroundsIndexRoute
}

const AdminPrivateBackgroundsRouteWithChildren = AdminPrivateBackgroundsRoute._addFileChildren(AdminPrivateBackgroundsRouteChildren)




const AdminProcessingRouteChildren = {
  AdminProcessingMetaIdRoute: AdminProcessingMetaIdRoute,AdminProcessingHooksRoute: AdminProcessingHooksRoute,AdminProcessingIndexRoute: AdminProcessingIndexRoute
}

const AdminProcessingRouteWithChildren = AdminProcessingRoute._addFileChildren(AdminProcessingRouteChildren)




const AdminQaConfigsRouteChildren = {
  AdminQaConfigsNewRoute: AdminQaConfigsNewRoute,AdminQaConfigsIndexRoute: AdminQaConfigsIndexRoute,AdminQaConfigsIdEditRoute: AdminQaConfigsIdEditRoute
}

const AdminQaConfigsRouteWithChildren = AdminQaConfigsRoute._addFileChildren(AdminQaConfigsRouteChildren)




const AdminRegionContractsRouteChildren = {
  AdminRegionContractsNewRoute: AdminRegionContractsNewRoute,AdminRegionContractsIndexRoute: AdminRegionContractsIndexRoute,AdminRegionContractsSlugEditRoute: AdminRegionContractsSlugEditRoute
}

const AdminRegionContractsRouteWithChildren = AdminRegionContractsRoute._addFileChildren(AdminRegionContractsRouteChildren)




const AdminRegionsRouteChildren = {
  AdminRegionsNewRoute: AdminRegionsNewRoute,AdminRegionsIndexRoute: AdminRegionsIndexRoute,AdminRegionsRegionSlugEditRoute: AdminRegionsRegionSlugEditRoute
}

const AdminRegionsRouteWithChildren = AdminRegionsRoute._addFileChildren(AdminRegionsRouteChildren)




const AdminReviewListsRouteChildren = {
  AdminReviewListsIndexRoute: AdminReviewListsIndexRoute,AdminReviewListsIdEditRoute: AdminReviewListsIdEditRoute
}

const AdminReviewListsRouteWithChildren = AdminReviewListsRoute._addFileChildren(AdminReviewListsRouteChildren)




const AdminUsersRouteChildren = {
  AdminUsersIndexRoute: AdminUsersIndexRoute,AdminUsersUserIdEditRoute: AdminUsersUserIdEditRoute
}

const AdminUsersRouteWithChildren = AdminUsersRoute._addFileChildren(AdminUsersRouteChildren)



const AdminRouteChildren = {
  AdminApiTokensRoute: AdminApiTokensRoute,AdminAuditLogRoute: AdminAuditLogRoute,AdminDataSchemaRoute: AdminDataSchemaRoute,AdminLayerOrderRoute: AdminLayerOrderRoute,AdminMapDatasetCategoriesRoute: AdminMapDatasetCategoriesRouteWithChildren,AdminMapDatasetUploadsRoute: AdminMapDatasetUploadsRouteWithChildren,AdminNoteFoldersRoute: AdminNoteFoldersRouteWithChildren,AdminPrivateBackgroundsRoute: AdminPrivateBackgroundsRouteWithChildren,AdminProcessingRoute: AdminProcessingRouteWithChildren,AdminQaConfigsRoute: AdminQaConfigsRouteWithChildren,AdminRegionContractsRoute: AdminRegionContractsRouteWithChildren,AdminRegionsRoute: AdminRegionsRouteWithChildren,AdminReviewListsRoute: AdminReviewListsRouteWithChildren,AdminUsersRoute: AdminUsersRouteWithChildren,AdminIndexRoute: AdminIndexRoute,AdminMembershipsNewRoute: AdminMembershipsNewRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)




const PreviewRouteChildren = {
  PreviewDefaultErrorRoute: PreviewDefaultErrorRoute,PreviewDefaultPendingRoute: PreviewDefaultPendingRoute,PreviewNotFoundRoute: PreviewNotFoundRoute,PreviewRegionErrorRoute: PreviewRegionErrorRoute,PreviewRegionPendingRoute: PreviewRegionPendingRoute,PreviewRootFallbackRoute: PreviewRootFallbackRoute
}

const PreviewRouteWithChildren = PreviewRoute._addFileChildren(PreviewRouteChildren)




const RegionenRegionSlugRouteRouteChildren = {
  RegionenRegionSlugHinweiseRoute: RegionenRegionSlugHinweiseRoute,RegionenRegionSlugMessenRoute: RegionenRegionSlugMessenRoute,RegionenRegionSlugPrueflistenRoute: RegionenRegionSlugPrueflistenRoute,RegionenRegionSlugQaRoute: RegionenRegionSlugQaRoute,RegionenRegionSlugSummierenRoute: RegionenRegionSlugSummierenRoute,RegionenRegionSlugIndexRoute: RegionenRegionSlugIndexRoute
}

const RegionenRegionSlugRouteRouteWithChildren = RegionenRegionSlugRouteRoute._addFileChildren(RegionenRegionSlugRouteRouteChildren)



const RegionenRouteChildren = {
  RegionenRegionSlugRouteRoute: RegionenRegionSlugRouteRouteWithChildren,RegionenStatsRoute: RegionenStatsRoute,RegionenIndexRoute: RegionenIndexRoute
}

const RegionenRouteWithChildren = RegionenRoute._addFileChildren(RegionenRouteChildren)




const ApiRegionsRouteChildren = {
  ApiRegionsRegionSlugUploadsCsvRoute: ApiRegionsRegionSlugUploadsCsvRoute
}

const ApiRegionsRouteWithChildren = ApiRegionsRoute._addFileChildren(ApiRegionsRouteChildren)




const ApiUploadsRouteChildren = {
  ApiUploadsSlugRoute: ApiUploadsSlugRoute,ApiUploadsCreateRoute: ApiUploadsCreateRoute
}

const ApiUploadsRouteWithChildren = ApiUploadsRoute._addFileChildren(ApiUploadsRouteChildren)




const ApiAdminProcessingRouteChildren = {
  ApiAdminProcessingMetaIdRoute: ApiAdminProcessingMetaIdRoute
}

const ApiAdminProcessingRouteWithChildren = ApiAdminProcessingRoute._addFileChildren(ApiAdminProcessingRouteChildren)




const ApiAdminRegionUploadsRouteChildren = {
  ApiAdminRegionUploadsUploadRoute: ApiAdminRegionUploadsUploadRoute
}

const ApiAdminRegionUploadsRouteWithChildren = ApiAdminRegionUploadsRoute._addFileChildren(ApiAdminRegionUploadsRouteChildren)




const ApiAdminRegionsRouteChildren = {
  ApiAdminRegionsSlugRoute: ApiAdminRegionsSlugRoute
}

const ApiAdminRegionsRouteWithChildren = ApiAdminRegionsRoute._addFileChildren(ApiAdminRegionsRouteChildren)




const ApiNotesRegionSlugFolderIdNoteIdRouteChildren = {
  ApiNotesRegionSlugFolderIdNoteIdCommentsRoute: ApiNotesRegionSlugFolderIdNoteIdCommentsRoute
}

const ApiNotesRegionSlugFolderIdNoteIdRouteWithChildren = ApiNotesRegionSlugFolderIdNoteIdRoute._addFileChildren(ApiNotesRegionSlugFolderIdNoteIdRouteChildren)



const ApiNotesRegionSlugFolderIdRouteChildren = {
  ApiNotesRegionSlugFolderIdNoteIdRoute: ApiNotesRegionSlugFolderIdNoteIdRouteWithChildren
}

const ApiNotesRegionSlugFolderIdRouteWithChildren = ApiNotesRegionSlugFolderIdRoute._addFileChildren(ApiNotesRegionSlugFolderIdRouteChildren)



const ApiNotesRegionSlugRouteChildren = {
  ApiNotesRegionSlugFolderIdRoute: ApiNotesRegionSlugFolderIdRouteWithChildren,ApiNotesRegionSlugDownloadRoute: ApiNotesRegionSlugDownloadRoute
}

const ApiNotesRegionSlugRouteWithChildren = ApiNotesRegionSlugRoute._addFileChildren(ApiNotesRegionSlugRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,PagesRoute: PagesRouteWithChildren,AdminRoute: AdminRouteWithChildren,McpRoute: McpRoute,PreviewRoute: PreviewRouteWithChildren,RegionenRoute: RegionenRouteWithChildren,ApiBoundaryRoute: ApiBoundaryRoute,ApiCampaignsRoute: ApiCampaignsRoute,ApiMapStyleRoute: ApiMapStyleRoute,ApiOsmcha2RssRewriteRoute: ApiOsmcha2RssRewriteRoute,ApiProcessingDatesRoute: ApiProcessingDatesRoute,ApiProcessingDatesMapillaryRoute: ApiProcessingDatesMapillaryRoute,ApiRegionsRoute: ApiRegionsRouteWithChildren,ApiStatsRoute: ApiStatsRoute,ApiUploadsRoute: ApiUploadsRouteWithChildren,ApiAdminAuditLogRoute: ApiAdminAuditLogRoute,ApiAdminProcessingRoute: ApiAdminProcessingRouteWithChildren,ApiAdminRegionUploadsRoute: ApiAdminRegionUploadsRouteWithChildren,ApiAdminRegionsRoute: ApiAdminRegionsRouteWithChildren,ApiAuthSplatRoute: ApiAuthSplatRoute,ApiAuthOsmTokenRoute: ApiAuthOsmTokenRoute,ApiNotesRegionSlugRoute: ApiNotesRegionSlugRouteWithChildren,ApiOsmNotesRssRoute: ApiOsmNotesRssRoute,ApiPrivateGenerateMaprouletteTasksRoute: ApiPrivateGenerateMaprouletteTasksRoute,ApiPrivatePostProcessingHookRoute: ApiPrivatePostProcessingHookRoute,ApiPrivatePostProcessingQaUpdateRoute: ApiPrivatePostProcessingQaUpdateRoute,ApiPrivateRegionsRoute: ApiPrivateRegionsRoute,ApiPrivateRegisterSqlFunctionsRoute: ApiPrivateRegisterSqlFunctionsRoute,ApiPrivateWarmCacheRoute: ApiPrivateWarmCacheRoute,ApiReviewListsUploadRoute: ApiReviewListsUploadRoute,ApiSignInOsmRoute: ApiSignInOsmRoute,ApiAdminDataSchemaImportRoute: ApiAdminDataSchemaImportRoute,ApiExportOgrRegionSlugTableNameRoute: ApiExportOgrRegionSlugTableNameRoute,ApiExportRegionSlugTableNameRoute: ApiExportRegionSlugTableNameRoute,ApiMaprouletteDataProjectKeyRoute: ApiMaprouletteDataProjectKeyRoute,ApiMaprouletteDataTest_tag_fixRoute: ApiMaprouletteDataTest_tag_fixRoute,ApiMaprouletteDataTest_tag_fix_cyclewaySharedRoute: ApiMaprouletteDataTest_tag_fix_cyclewaySharedRoute,ApiMaprouletteDataTest_tag_fix_twoRoute: ApiMaprouletteDataTest_tag_fix_twoRoute,ApiMaprouletteStatisticProxyChallengeIdRoute: ApiMaprouletteStatisticProxyChallengeIdRoute,ApiRegionUploadsIdFilenameRoute: ApiRegionUploadsIdFilenameRoute,ApiAdminQaConfigsIdExportCsvRoute: ApiAdminQaConfigsIdExportCsvRoute,ApiPrivateBackgroundsSlugZXYRoute: ApiPrivateBackgroundsSlugZXYRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)